import { compact, get, isEmpty } from 'lodash-es';
import { joinTruthyBy } from '@is24at/react-utils';
import { SPACE_DELIMITER, UNDEFINED } from '@is24at/react-constants';

export const zipCode = (expose: any) => get(expose, 'zipCode');
export const city = (expose: any) => get(expose, 'city');
export const street = (expose: any) => get(expose, 'street');
export const streetNumber = (expose: any) => get(expose, 'streetNumber');
export const countryCode = (expose: any) => get(expose, 'countryCode');
/**
 * @returns {string|undefined} returns concatenated `zip` and `city`
 */
export const zipCityString = (expose: any) => {
  const result = joinTruthyBy([zipCode(expose), city(expose)], SPACE_DELIMITER);
  return isEmpty(result) ? UNDEFINED : result;
};

/**
 * @returns {string|undefined} returns concatenated `street` and `streetNumber`
 */
export const streetString = (expose: any) => {
  if (!street(expose)) {
    return UNDEFINED;
  }

  return joinTruthyBy([street(expose), streetNumber(expose)], SPACE_DELIMITER);
};

export const addressLines = (expose: any) =>
  compact([streetString(expose), zipCityString(expose)]);
